import { canDo } from '../../utils/roleAccess';

function getCorporateUserId(user) {
  return user?.corporateUserId ?? user?.id;
}

function isParticipantOrg(item) {
  return item?.is_participant !== false;
}

function resolveForumScope(forum) {
  const individuals = (forum?.ForumMembers || []).filter((m) => m.role === 'participant');
  const subDepartments = (forum?.ForumSubDepartments || []).filter(isParticipantOrg);
  const departments = (forum?.ForumDepartments || []).filter(isParticipantOrg);
  const branches = (forum?.ForumBranches || []).filter(isParticipantOrg);

  if (individuals.length > 0) return 'individual';
  if (subDepartments.length > 0) return 'sub_department';
  if (departments.length > 0) return 'department';
  if (branches.length > 0) return 'branch';
  return 'none';
}

export function isForumParticipant(forum, user) {
  const userId = getCorporateUserId(user);
  if (!forum || !userId) return false;

  if (Number(forum.created_by) === Number(userId)) return true;

  const scope = resolveForumScope(forum);
  const userBranchId = user.branchId ?? user.branch_id;
  const userDepartmentId = user.departmentId ?? user.department_id;
  const userSubDepartmentId = user.subDepartmentId ?? user.sub_department_id;

  if (scope === 'individual') {
    return (forum.ForumMembers || []).some(
      (m) => m.role === 'participant'
        && (Number(m.user_id) === Number(userId) || Number(m.CorporateUser?.id) === Number(userId))
    );
  }

  if (scope === 'sub_department') {
    const ids = (forum.ForumSubDepartments || [])
      .filter(isParticipantOrg)
      .map((item) => item.sub_department_id || item.SubDepartment?.id)
      .filter(Boolean);
    return userSubDepartmentId && ids.includes(userSubDepartmentId);
  }

  if (scope === 'department') {
    const ids = (forum.ForumDepartments || [])
      .filter(isParticipantOrg)
      .map((item) => item.department_id || item.Department?.id)
      .filter(Boolean);
    return userDepartmentId && ids.includes(userDepartmentId);
  }

  if (scope === 'branch') {
    const ids = (forum.ForumBranches || [])
      .filter(isParticipantOrg)
      .map((item) => item.branch_id || item.Branch?.id)
      .filter(Boolean);
    return userBranchId && ids.includes(userBranchId);
  }

  return false;
}

export function getForumPermissions(forum, user) {
  const userId = getCorporateUserId(user);
  const isCreator = !!forum && Number(forum.created_by) === Number(userId);
  const isParticipant = isForumParticipant(forum, user);

  return {
    isCreator,
    isParticipant,
    canEdit: (isCreator || (!!forum?.allow_participants_edit && isParticipant)) && canDo('forum', 'create_edit'),
    canSetClosed: isCreator || (!!forum?.allow_participants_close && isParticipant),
    canChangeStatus: isCreator || isParticipant,
    canDelete: canDo('forum', 'delete'),
  };
}

export { resolveForumScope };
